/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_Recent_Chats_BodyInputs */



/**
* | output |
* | --- |
* | "Your latest conversations, one click away." |
*
* @param {Onboarding_Tour_Recent_Chats_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_recent_chats_body = /** @type {((inputs?: Onboarding_Tour_Recent_Chats_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Recent_Chats_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deine neuesten Unterhaltungen, einen Klick entfernt.")
	return /** @type {LocalizedString} */ ("Your latest conversations, one click away.")
});